import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatDialogRef } from '@angular/material/dialog';
import { ModuleConfigService } from '../../services/module-config/module-config.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-hol-modal-prompt',
  templateUrl: './hol-modal-prompt.component.html',
  styleUrls: ['./hol-modal-prompt.component.scss'],
})
export class HolModalPromptComponent implements OnInit {
  itemsData;
  // @Input() data;
  contentText: string;
  text = new UntypedFormControl('', [Validators.required]);

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    protected translate: TranslateService,
    public moduleConfig: ModuleConfigService,
    public dialogRef: MatDialogRef<HolModalPromptComponent>,
  ) {
    this.contentText = data.contentText;
  }

  /* statusControl: FormControl;
  commentControl: FormControl;
  */

  getErrorMessage() {
    return this.text.hasError('required') ? 'You must enter a value' : '';
  }

  ngOnInit(): void {
    if (!this.data) {
      throw new Error('HolModalComponent::data is required');
    }
  }

  cancel(): void {
    this.dialogRef.close(false);
  }

  valid(): void {
    this.dialogRef.close(this.text.value);
  }
}
